module.exports = __webpack_public_path__ + "img/89204B_17080D_DA4377_F780B5-256px.6c0ff07e.png";